export default __webpack_public_path__ + "static/tfa-b4bd8589946e5215f303a059da061d35.png";